import React from 'react'

import { CustomTheme, ModalTypes, fonts, NotificationModalPalette } from '@masfront/common-b2c'

import { Card, Dialog, Button, Divider, Box, Typography } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import { makeStyles, createStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme: CustomTheme) => {
  return createStyles({
    root: {
      display: 'flex',
      justifyContent: 'center',
      marginTop: theme.spacing(11),
      maxHeight: 'fit-content',
    },
    card: {
      borderBottom: ({ borderColor }: { borderColor?: NotificationModalPalette | undefined }) => {
        return borderColor && `4px solid ${theme?.palette[borderColor]?.main}`
      },
      width: '936px',
      borderRadius: '14px',
    },
    icon: {
      cursor: 'pointer',
      fontSize: fonts.size.huge,
    },
  })
})

export interface ContentModalProps {
  isOpen: boolean
  onClose?: () => void
  title?: string
  children: React.ReactNode
  onNextStep?: () => void
  confirmButtonDisabled?: boolean
  cancelButtonDisabled?: boolean
  confirmButtonTxt?: string
  cancelButtonTxt?: string
  type?: string
  withoutButtons?: boolean
  dataHook?: string
}

const ContentModal: React.FC<ContentModalProps> = ({
  isOpen,
  onClose,
  title,
  children,
  onNextStep,
  confirmButtonDisabled = false,
  cancelButtonDisabled = false,
  confirmButtonTxt = 'Continuar',
  cancelButtonTxt = 'Cancelar',
  type,
  withoutButtons = false,
  dataHook = '',
}) => {
  let borderColor
  if (type) borderColor = ModalTypes[type].borderColor
  const classes = useStyles({ borderColor })

  return (
    <Dialog
      className={classes.root}
      maxWidth={false}
      onClose={onClose}
      open={isOpen}
      data-hook={dataHook}
    >
      <Card className={classes.card}>
        {title ? (
          <>
            <Box
              px={8}
              pb={4}
              pt={8}
              display="flex"
              justifyContent="space-between"
              flexDirection="row"
            >
              <Typography variant="h2">{title}</Typography>
              <CloseIcon className={classes.icon} onClick={onClose} />
            </Box>
            <Box px={8}>
              <Divider className="strong" />
            </Box>
          </>
        ) : (
          <Box display="flex" justifyContent="flex-end" p={8}>
            <CloseIcon className={classes.icon} onClick={onClose} />
          </Box>
        )}
        <Box px={8}>{children}</Box>
        {!withoutButtons && (
          <Box p={8} display="flex">
            <Box mr={6}>
              <Button
                variant="contained"
                color="secondary"
                disabled={confirmButtonDisabled}
                onClick={onNextStep}
              >
                {confirmButtonTxt}
              </Button>
            </Box>
            <Button
              variant="outlined"
              color="secondary"
              disabled={cancelButtonDisabled}
              onClick={onClose}
            >
              {cancelButtonTxt}
            </Button>
          </Box>
        )}
      </Card>
    </Dialog>
  )
}

export default ContentModal
